import React from "react";
import "../Aboutus/Text.css";

const Text = () => {
  return (
    <section className="text-wrapper-t">
      <div className="text-left-t">
        <h1 className="heading-t">About Us</h1>
        <p className="quote-t">
          Packaging isn’t just a layer — it’s protection, precision, and purpose
          for orthopedic care.
        </p>
        <div className="quote-image-t">
          <img src="/ow.webp" alt="Orthopedic Instruments Packaging" />
        </div>
      </div>

      <div className="text-right-t">
        <div className="block-t">
          <h2 className="block-heading-t">Our Vision</h2>
          <p className="block-desc-t">
            To revolutionize orthopedic instrument packaging with intelligent,
            sterile, and sustainable designs that support both global healthcare
            and surgical precision.
          </p>
        </div>

        <div className="block-t">
          <h2 className="block-heading-t">Our Mission</h2>
          <p className="block-desc-t">
            We aim to provide packaging solutions that not only protect
            orthopedic tools but enhance operational efficiency, ensuring every
            product arrives with safety and confidence.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Text;
